import { APIBaseURL } from "../Environment/Environment";

const API_URL = {
  ADMIN_LOGIN: APIBaseURL + "admin/login",
  Forget_Password: APIBaseURL + "admin/forgot_password",
  RESET_Password: APIBaseURL + "admin/reset_password",
  CHANGE_PASSWORD: APIBaseURL + "admin/changePassword",
  ADMIN_DETAIL: APIBaseURL + "admin/getAdmin",
  UPDATE_PROFILE: APIBaseURL + "admin/updateProfile",

  GET_ALL_USER: APIBaseURL + "admin/userList",
  DELETE_USER: APIBaseURL + "admin/delete_user",
  CHANGE_USER_STATUS: APIBaseURL + "admin/userStatusChange",

  GET_CATEGORY_LIST: APIBaseURL + "admin/categoryList",
  EDIT_CATEGORY: APIBaseURL + "admin/updateCategory",
  CHANGE_CATEGORY_STATUS: APIBaseURL + "admin/categoryStatusChange",
  // product api

  GET_PRODUCT_LIST: APIBaseURL + "admin/productList",
  ADD_PRODUCT: APIBaseURL + "admin/createProduct",
  UPDATE_PRODUCT: APIBaseURL + "admin/updateProduct",
  PRODUCT_BY_ID: APIBaseURL + "admin/productListById",
  CATEGORY_LIST_WITHOUT_PAGINATION: APIBaseURL + "admin/activeCategoryList",
  CHANGE_PRODUCT_STATUS: APIBaseURL + "admin/productStatusChange",
  DELETE_PRODUCT: APIBaseURL + "admin/deleteProduct",

  GET_CONTENT_LIST: APIBaseURL + "admin/contentList",
  EDIT_CONTENT: APIBaseURL + "admin/updateContent",
  CHANGE_CONTENT_STATUS: APIBaseURL + "admin/contentStatusChange",

  // canvas frames option
  IMAGE_LISTING: APIBaseURL + "admin/imageListingList",
  UPDATE_IMAGE_LISTING: APIBaseURL + "admin/updateImageListing",
  UPDATE_IMAGE_LISTING_STATUS: APIBaseURL + "admin/imageStatusChange",

  EDGE_LISTING: APIBaseURL + "admin/edgeListingList",
  UPDATE_EDGE_LISTING: APIBaseURL + "admin/updateEdgeListing",

  FRAMES_LISTING: APIBaseURL + "admin/frameListingList",
  ADD_FRAMES_LISTING: APIBaseURL + "admin/addFrameListing",
  UPDATE_FRAMES_LISTING: APIBaseURL + "updateFrameListing",
  DELETE_FRAME: APIBaseURL + "admin/deleteFrame",

  // PRICE listing 
  GET_PRICE_LIST: APIBaseURL + "admin/pricesizeList",
  UPDATE_PRICE_LIST: APIBaseURL + "update_single_panel",
  CHANGE_PRICE_STATUS: APIBaseURL + "admin/priceSizeStatusChange",

  // GALLERYWALL CONFIG listing 
  GET_GALLERYWALL_CONFIG_LIST: APIBaseURL + "admin/galleryWallList",
  UPDATE_GALLERYWALL_CONFIG: APIBaseURL + "admin/updateGalleryWall",
  DELETE_GALLERYWALL_CONFIG: APIBaseURL + "admin/DeletegalleryWall",
  CHANGE_GALLERYWALL_CONFIG_STATUS: APIBaseURL + "admin/galleryStatusChange",

  //  company info
  GET_COMPANY_INFO: APIBaseURL + "admin/company_info",
  UPDATE_COMPANY_INFO: APIBaseURL + "admin/update_company_info",

  //  shipping api 
  GET_SHIPPING_CHARGE: APIBaseURL + "admin/shippingCharge",
  UPDATE_SHIPPING_CHARGE: APIBaseURL + "admin/updateShippingCharge",

  GET_SHIPPING_INFO: APIBaseURL + "admin/shippingInfo",
  ADD_SHIPPING_INFO: APIBaseURL + "admin/addShippingInfo",
  UPDATE_SHIPPING_INFO: APIBaseURL + "admin/updateShippingInfo",
  DELETE_SHIPPING_INFO: APIBaseURL + "admin/deleteShippingInfo",

  // photoSplits listing 
  GET_PHOTO_SPLITS_LIST: APIBaseURL + "admin/photosplitsList",
  UPDATE_PHOTO_SPLITS: APIBaseURL + "admin/updatephotoplits",
  DELETE_PHOTO_SPLITS: APIBaseURL + "admin/Deletephotosplits",
  CHANGE_PHOTO_SPLITS_STATUS: APIBaseURL + "admin/photosplitsStatusChange",
  ADD_PHOTO_SPLITS: APIBaseURL + "admin/addphotoplits",

  // coupon listing 
  GET_COUPON_LIST: APIBaseURL + "admin/couponList",
  UPDATE_COUPON: APIBaseURL + "admin/updateCoupon",
  DELETE_COUPON: APIBaseURL + "admin/deleteCoupon",
  CHANGE_COUPON_STATUS: APIBaseURL + "admin/couponStatusChange",
  ADD_COUPON: APIBaseURL + "admin/addCoupon",

  // BANNER listing 
  GET_BANNER_LIST: APIBaseURL + "admin/bannerList",
  UPDATE_BANNER: APIBaseURL + "admin/updateBannerList",
  DELETE_BANNER: APIBaseURL + "admin/deleteBannerList",
  CHANGE_BANNER_STATUS: APIBaseURL + "admin/bannerStatusChange",
  ADD_BANNER: APIBaseURL + "admin/addBannerList",

  // sales tax
  GET_SALES_TAX: APIBaseURL + "admin/salesTaxList",
  ADD_SALES_TAX: APIBaseURL + "admin/",
  UPDATE_SALES_TAX: APIBaseURL + "admin/updateSalesTax",
  GET_STATE_LIST_BY_ID: APIBaseURL + "admin/statelistbyId",

  // Digital Service listing 
  GET_DIGITAL_SERVICE_LIST: APIBaseURL + "admin/additionalDigitalList",
  UPDATE_DIGITAL_SERVICE: APIBaseURL + "admin/updateAdditionaldigital",
  CHANGE_STATUS_DIGITAL: APIBaseURL + 'admin/statusAdditionaldigital',
  ADD_DIGITAL_SERVICES: APIBaseURL + 'admin/addAdditionaldigital',


  // footer name listing 
  GET_FOOTER_NAME_LIST: APIBaseURL + "admin/footer-list",
  UPDATE_FOOTER_LIST: APIBaseURL + "admin/footer-update",
  CHANGE_STATUS_FOOTER_LIST: APIBaseURL + "admin/footer-status-update",

  // payment credentials listing 
  GET_PAYMENT_CREDENTIALS: APIBaseURL + "admin/braintree_info",
  UPDATE_PAYMENT_CREDENTIALS: APIBaseURL + "admin/updatebraintree_info",

  // SEO LIST
  GET_SEO_LIST: APIBaseURL + "admin/seoList",
  CHANGE_STATUS_SEO_LIST: APIBaseURL + "admin/seoStatusChange",
  UPDATE_SEO_LIST: APIBaseURL + "admin/updateSeo",

  // customer management api  
  GET_CART_MAIL: APIBaseURL + "admin/cart_email_details",
  UPDATE_CART_MAIL: APIBaseURL + "admin/updateCart_email",

   // customer query api  
   QUERY_USER_LIST: APIBaseURL + "admin/getAllContacts", 

  // TOP Questions listing 
  GET_QUESTIONS_LIST: APIBaseURL + "admin/topquestionList",
  CREATE_QUESTION_LIST: APIBaseURL + "admin/addTopquestion",
  UPDATE_QUESTIONS: APIBaseURL + "admin/edittopquestion",
  DELETE_QUESTIONS: APIBaseURL + "admin/DeleteTopquestion",

  // TOP Questions Type listing 
  GET_QUESTIONS_TYPE_LIST: APIBaseURL + "admin/questionTypeList",
  CREATE_QUESTION_TYPE_LIST: APIBaseURL + "admin/AddQuestionType",
  UPDATE_QUESTIONS_TYPE: APIBaseURL + "admin/updateQuestionType",
  DELETE_QUESTIONS_TYPE: APIBaseURL + "admin/deleteQuestionType",

  // Personal Shopper  listing 
  GET_PERSONAL_SHOPPER_LIST: APIBaseURL + "admin/personalshopperList",
  DELETE_PERSONAL_SHOPPER: APIBaseURL + "admin/DeletePersonalShopper",

  // Mail listing 
  GET_MAIL_LIST: APIBaseURL + "admin/emailContentList",
  UPDATE_MAIL: APIBaseURL + "admin/updateEmailContent",
  CHANGE_MAIL_STATUS: APIBaseURL + "admin/emailContentStatusChange",

  // order management listing 
  GET_ORDER_LIST: APIBaseURL + "admin/orderList",
  UPDATE_ORDER: APIBaseURL + "admin/",
  CHANGE_ORDER_STATUS: APIBaseURL + "admin/order_status",
  ORDER_BY_ID: APIBaseURL + 'admin/orderListById',

  // header image listing
  GET_HEADER_IMAGE_LIST: APIBaseURL + "admin/headerImageList",
  CHANGE_HEADER_IMAGE_LIST: APIBaseURL + "admin/headerImageChange",
  UPDATE_HEADER_IMAGE_LIST: APIBaseURL + "admin/updateheaderImage",

  // Export Customer
  GET_LIST_TO_EXPORT: APIBaseURL + "admin/user-list-without-pagination",

  // STATE listing 
  GET_STATES_LIST: APIBaseURL + "admin/statesList",
  ADD_STATE_LIST: APIBaseURL + "admin/addStateList",
  UPDATE_STATE: APIBaseURL + "admin/updateState",
  DELETE_STATE: APIBaseURL + "admin/deleteState",
  GET_COUNTRY_LIST: APIBaseURL + "admin/countryList",

  // DELIVERY PARTNER listing 
  GET_DELIVERY_LIST: APIBaseURL + "getDeliveryPartner",
  ADD_DELIVERY: APIBaseURL + "addDeliveryPartner",
  UPDATE_DELIVERY: APIBaseURL + "updateDeliveryPartner",
  CHANGE_STATUS_DELIVERY: APIBaseURL + "statusChangeDeliveryPartner",

  //  DASHBOARD COUNT
  GET_DASHBOARD_COUNT: APIBaseURL + "admin/dashboardCount",
  GET_USER_GRAPH_DATA: APIBaseURL + "admin/YearlyUserListGraph",

  // SHIPPING PAGE
  GET_SHIPPING_PAGE_DETAIL: APIBaseURL + "admin/shippingDetails",
  UPDATE_SHIPPING: APIBaseURL + "admin/updateShipping",

  // TRANSACTION 
  GET_TRANSACTION: APIBaseURL + "admin/getAllPaynment",


  //GET SERVER IMAGE

  GET_IMAGE: APIBaseURL + "admin/generatesignedUrl",

  //PERMANENT
  PERMANENT_DELETE: APIBaseURL + "admin/permanent-delete",


  // PLEXI PRINT
  GET_PLEXI_LIST: APIBaseURL + "get_artplexiWood",

  // CANVAS PRINT
  GET_CANVAS_LIST: APIBaseURL + "single_panel",
  GET_SPLIT_LIST: APIBaseURL + "splitcanvas",
  GET_GALLERY_LIST: APIBaseURL + "gallery_walls",
  GET_STORY_LIST: APIBaseURL + "story-canvas",

  UPDATE_GALLERY_LIST: APIBaseURL + "update_gallery_walls_by_id",
  UPDATE_STORY_LIST: APIBaseURL + "update_story-canvas_by_id",
  UPDATE_SPLIT_CANVAS: APIBaseURL + "splitcanvasUpdateById",
  UPDATE_PLEXI_WOOD_ARTTRAY_CANVAS: APIBaseURL + "update_artplexiWood",

  //GIFT CARD API

  UPDATE_GIFT_CARDS: APIBaseURL + "admin/updateGiftCard",
  GIFT_VOUCHERS: APIBaseURL + "gift_cards_list",
  ADD_GIFT_CARDS: APIBaseURL + "add_gift_cards",

  // CONTENT Api's
  GET_CONTENT_DETAILS: APIBaseURL + "admin/getcontent",
  UPDATE_CONTENT: APIBaseURL + "admin/updateContent",
  
  GET_BIO_DETAIL: APIBaseURL + "admin/getBio",
  UPDATE_BIO: APIBaseURL + "admin/updateBio",

};

export { API_URL };
